import React from 'react';
import {connect} from 'react-redux';
import InboxIcon from 'material-ui-icons/Inbox';
import PagesIcon from 'material-ui-icons/LibraryBooks';
import PageTemplatesIcon from 'material-ui-icons/Tab';
import GridIcon from 'material-ui-icons/GridOn';
import ExitToAppIcon from 'material-ui-icons/ExitToApp';
import PeopleIcon from 'material-ui-icons/People';
import SettingsIcon from 'material-ui-icons/Settings';
import MenusIcon from 'material-ui-icons/ViewList';
import LabelIcon from 'material-ui-icons/Label';
import StaffIcon from 'material-ui-icons/Face';
import RedirectIcon from 'material-ui-icons/Repeat';
import TagsIcon from 'material-ui-icons/LocalOffer';
import FaqsIcon from 'material-ui-icons/QuestionAnswer';
import MyAccountIcon from 'material-ui-icons/AccountCircle';
import WebinarsIcon from 'material-ui-icons/Event';
import MenuItem from './menu_item';
import {List, Tooltip} from 'material-ui';
import {
    showSideMenuConfiguration,
    showSideMenuBlocks,
    showSideMenuUsers,
    showSideMenuPages,
} from '../../components/permissions/permissions';

export class MainMenu extends React.Component {
    constructor() {
        super();
        this.state = {
            activeItem: {},
        };
    }

    toggleActiveItem = (name) => {
        this.setState({
            activeItem: {
                [name]: true,
            },
        });
    };

    render() {
        let MenuUsers = showSideMenuUsers(() => (
            <MenuItem
                text="Users"
                buttonAction={'/users'}
                onClick={(e) => this.toggleActiveItem('users')}
                activeItem={this.state.activeItem.users}
            >
                <PeopleIcon
                    className={
                        this.state.activeItem.users ? 'menuIcons active ' : ''
                    }
                />
            </MenuItem>
        ));

        let MenuBlocks = showSideMenuBlocks(() => (
            <MenuItem
                text="Blocks"
                buttonAction={'/blocks'}
                onClick={(e) => this.toggleActiveItem('blocks')}
                activeItem={this.state.activeItem.blocks}
            >
                <GridIcon
                    className={
                        this.state.activeItem.blocks ? 'menuIcons active' : ''
                    }
                />
            </MenuItem>
        ));

        let MenuLabels = showSideMenuBlocks(() => (
            <MenuItem
                text="Labels"
                buttonAction={'/labels'}
                onClick={(e) => this.toggleActiveItem('labels')}
                activeItem={this.state.activeItem.labels}
            >
                <LabelIcon
                    className={
                        this.state.activeItem.labels ? 'menuIcons active' : ''
                    }
                />
            </MenuItem>
        ));

        let MenuConfiguration = showSideMenuConfiguration(() => (
            <MenuItem
                text="Configuration"
                buttonAction={'/configure'}
                onClick={(e) => this.toggleActiveItem('configure')}
                activeItem={this.state.activeItem.configure}
            >
                <Tooltip title="Configuration">
                    <SettingsIcon
                        className={
                            this.state.activeItem.configure
                                ? 'menuIcons active'
                                : ''
                        }
                    />
                </Tooltip>
            </MenuItem>
        ));

        let MenuPages = showSideMenuPages(() => (
            <MenuItem
                text="Pages"
                buttonAction={'/pages'}
                onClick={(e) => this.toggleActiveItem('pages')}
                activeItem={this.state.activeItem.pages}
            >
                <PagesIcon
                    className={
                        this.state.activeItem.pages ? 'menuIcons active' : ''
                    }
                />
            </MenuItem>
        ));

        let MenuWebinars = () => (
            <MenuItem
                text="Webinars"
                buttonAction={'/webinars'}
                onClick={(e) => this.toggleActiveItem('webinars')}
                activeItem={this.state.activeItem.webinars}
            >
                <WebinarsIcon
                    className={
                        this.state.activeItem.webinars ? 'menuIcons active' : ''
                    }
                />
            </MenuItem>
        );

        let MenuPageTemplates = showSideMenuPages(() => (
            <MenuItem
                text="Page Templates"
                buttonAction={'/templates'}
                onClick={(e) => this.toggleActiveItem('templates')}
                activeItem={this.state.activeItem.templates}
            >
                <Tooltip title="Templates">
                    <PageTemplatesIcon
                        className={
                            this.state.activeItem.templates
                                ? 'menuIcons active'
                                : ''
                        }
                    />
                </Tooltip>
            </MenuItem>
        ));

        let MenuSiteMenus = showSideMenuPages(() => (
            <MenuItem
                text="Menus"
                buttonAction={'/menus'}
                onClick={(e) => this.toggleActiveItem('menus')}
                activeItem={this.state.activeItem.menus}
            >
                <MenusIcon
                    className={
                        this.state.activeItem.menus ? 'menuIcons active' : ''
                    }
                />
            </MenuItem>
        ));

        let MenuStaff = showSideMenuPages(() => (
            <MenuItem
                text="Staff"
                buttonAction={'/staff'}
                onClick={(e) => this.toggleActiveItem('staff')}
                activeItem={this.state.activeItem.staff}
            >
                <StaffIcon
                    className={
                        this.state.activeItem.staff ? 'menuIcons active' : ''
                    }
                />
            </MenuItem>
        ));

        let MenuRedirects = showSideMenuBlocks(() => (
            <MenuItem
                text="Redirects"
                buttonAction={'/redirects'}
                onClick={(e) => this.toggleActiveItem('redirects')}
                activeItem={this.state.activeItem.redirects}
            >
                <RedirectIcon
                    className={
                        this.state.activeItem.redirects
                            ? 'menuIcons active'
                            : ''
                    }
                />
            </MenuItem>
        ));

        let MenuTags = showSideMenuBlocks(() => (
            <MenuItem
                text="Tags"
                buttonAction={'/tags'}
                onClick={(e) => this.toggleActiveItem('tags')}
                activeItem={this.state.activeItem.tags}
            >
                <TagsIcon
                    className={
                        this.state.activeItem.tags ? 'menuIcons active' : ''
                    }
                />
            </MenuItem>
        ));

        let MenuFaqs = showSideMenuBlocks(() => (
            <MenuItem
                text="FAQs"
                buttonAction={'/faqs'}
                onClick={(e) => this.toggleActiveItem('faqs')}
                activeItem={this.state.activeItem.faqs}
            >
                <FaqsIcon
                    className={
                        this.state.activeItem.faqs ? 'menuIcons active' : ''
                    }
                />
            </MenuItem>
        ));

        let MenuDashboard = () => (
            <MenuItem
                text="Dashboard"
                buttonAction={'/dashboard'}
                onClick={(e) => this.toggleActiveItem('dashboard')}
                activeItem={this.state.activeItem.dashboard}
            >
                <InboxIcon
                    className={
                        this.state.activeItem.dashboard
                            ? 'menuIcons active'
                            : ''
                    }
                />
            </MenuItem>
        );

        let MenuMyAccount = () => (
            <MenuItem
                text="My Account"
                buttonAction={'/myaccount/' + this.props.userId}
                onClick={(e) => this.toggleActiveItem('myaccount')}
                activeItem={this.state.activeItem.myaccount}
            >
                <MyAccountIcon
                    className={
                        this.state.activeItem.myaccount
                            ? 'menuIcons active'
                            : ''
                    }
                />
            </MenuItem>
        );

        let MenuSignOut = () => (
            <MenuItem text="Sign Out" buttonAction={'/logout'}>
                <ExitToAppIcon />
            </MenuItem>
        );

        return (
            <List>
                <MenuDashboard />
                <MenuMyAccount />
                <MenuPages />
                <MenuWebinars />
                <MenuPageTemplates />
                <MenuBlocks />
                <MenuFaqs />
                <MenuLabels />
                <MenuSiteMenus />
                <MenuStaff />
                <MenuRedirects />
                <MenuTags />
                <MenuUsers />
                <MenuConfiguration />
                <MenuSignOut />
            </List>
        );
    }
}

const mapStateToProps = state => ({
    userId: state.auth.user.id,
});

export default connect(mapStateToProps)(MainMenu);



// WEBPACK FOOTER //
// ./src/containers/layout/main_menu.js